class CampaignGrid {
	constructor(campaigns) {
		this.campaigns = campaigns;
	}

	renderCampaigns() {
        swellAPI.getActiveCampaigns()
		this.campaigns.forEach((campaign) => {
			$(".loyalty-campaigns-container").append(
				$("<a>", {
					"data-campaign-id": campaign.id,
					"data-display-mode" : "modal",
                  "id": campaign.id
				}
					).addClass("loyalty-campaign").addClass("swell-campaign-link").append(
						$("<div>").addClass("loyalty-campaign-circle").append(
                            $("<div>").addClass("loyalty-campaign-cost-container").append(
                                $("<div>").addClass("loyalty-campaign-cost-number").text(campaign.rewardPoints),
                                $("<i>").addClass("loyalty-campaign-icon"),
                                $("<div>").addClass("loyslty-campaign-pieces-text").text("pieces")
                            ),
                            $("<div>").addClass("loyalty-campaign-hover-container").append(
                                $("<div>").addClass("loyalty-campaign-description-text").text(campaign.details)
                            )
                        ),
                        $("<div>").addClass("loyalty-campaign-name").text(campaign.title)
					)

                )
                 
        })
        

           
         $(".loyalty-campaign-circle").on('mouseover', (event) => {
            
        $(event.currentTarget).addClass("loyalty-hover-show")
     }).on('mouseout', () => {
        $(event.currentTarget).removeClass("loyalty-hover-show");
     })
     
 
    
var referCampaign = document.getElementById('430562');
 referCampaign.setAttribute('href', '#yotpo-refer-module');
referCampaign.setAttribute("data-display-mode", "direct",)


        

    }
    


}